import React from 'react';
import * as ReactDOM from "react-dom/client";
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import './index.css';
import reportWebVitals from './reportWebVitals';
import Root from './components/routes/root/root'
import Editor from './components/routes/editor/editor-root';
import ErrorPage from "./components/error-page";
import AuthCtxtProvider from './components/AuthCtxtProvider';
import ProtectedRoute from './components/ProtectedRoute';
import LoginPage from './components/routes/login/login-root';
import Portfolio from './components/routes/editor/portfolio';
import TextEditor from './components/routes/editor/tiptap/TextEditor';
import TipTapEditor from './components/routes/editor/tiptap/TipTapEditor';
import TipTapViewer from './components/routes/editor/tiptap/TipTapViewer';
import TTMenu from './components/routes/editor/tiptap/TTMenu';

import CDNImageDemo from './components/routes/root/demo/CDNImageDemo';
import CDNDocDemo from './components/routes/root/demo/CDNDocDemo';
import DocEditDemo from './components/routes/editor/demo/DocEditDemo';
import FileEditDemo from './components/routes/editor/demo/FileEditDemo';
import LandingPage from './components/routes/LandingPage';
import ArtistStatement from './components/routes/ArtistStatement';
import ArtistStatementEditor from './components/routes/editor/ArtistStatementEditor';
import { ConfigCtxtProvider } from './components/ConfigCtxtProvider';
import 'bootstrap/dist/css/bootstrap.min.css';

const router = createBrowserRouter([
  {
    path: "/",
    element: <Root />,  
    errorElement: <ErrorPage />,
    children: [
      {
        path: "",
        element: <LandingPage/>
      },
      {
        path: "artist_statement",
        element: <ArtistStatement />  
      },
      {
        path: "portfolio",
        element: <h1>Portfolio Page</h1>
      },
      {
        path: "portfolio/:collection_id",
        element: <h1>Portfolio Collection Page</h1>
      },
      {
        path: "shop",
        element: <h1>Shop Page</h1>
      },
      {
        path: "contact",
        element: <h1>Contact Page</h1>
      },
      {
        path: "cdn_image_demo",
        element: <CDNImageDemo />
      },
      {
        path: "cdn_document_demo",
        element: <CDNDocDemo />
      },
      {
        path: "test",
        element: <TTMenu />
      }
    ]
  },
  {
    path: "/editor",
    element: <AuthCtxtProvider><Editor /></AuthCtxtProvider>,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "",
        element: <ProtectedRoute><h1>Landing Page</h1><TipTapViewer /></ProtectedRoute>
      },
      {
        path: "artist_statement",
        element: <ProtectedRoute><ArtistStatementEditor /></ProtectedRoute>
      },
      {
        path: "portfolio",
        element: <ProtectedRoute><Portfolio /></ProtectedRoute>
      },
      {
        path: "portfolio/:collection_id",
        element: <ProtectedRoute><h1>Collection Page</h1></ProtectedRoute>
      },
      {
        path: "shop",
        element: <ProtectedRoute><h1>Shop Page</h1></ProtectedRoute>
      },
      {
        path: "contact",
        element: <ProtectedRoute><h1>Contact Page</h1><TextEditor /></ProtectedRoute>
      }, 
      {
        path: "file_edit_demo",
        element: <ProtectedRoute><FileEditDemo/></ProtectedRoute>
      },
      {
        path: "doc_edit_demo",
        element: <ProtectedRoute> <DocEditDemo /></ProtectedRoute>
      }
    ]
  },
  {
    path: "/login",
    element: <AuthCtxtProvider><LoginPage /></AuthCtxtProvider>,
  }
]);


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ConfigCtxtProvider>
        <RouterProvider router={router} />
    </ConfigCtxtProvider> 
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
